
import { config } from '../config';
import { isAuthenticated } from '../routes/ProtectedRoute';
import { SIGNUP_WITHOUT_PAYMENT_FREE_TRIAL_PLAN_ID } from '../types/signupWithoutPayment';
import { STORAGE_KEYS } from './storage.util';

/**
 * Builds the AI webinar try-ai-flow URL with a single state param.
 * State can be a combined JSON string { state, ew_jwt } so the receiving app gets both.
 * Used by AILogin and SignupVerifyEmail for consistent redirect after login/signup.
 * @param stateParam - Combined state (e.g. JSON with state + ew_jwt), or plain state; if empty, falls back to localStorage STATE.
 */
export function getAilaunchRedirectUrl(stateParam?: string | null): string {
  const baseUrl =
    config.easywebinar_v2_url && config.easywebinar_v2_url !== 'N/A'
      ? config.easywebinar_v2_url
      : window.location.origin;
  const state =
    (stateParam != null && String(stateParam).trim() !== '')
      ? String(stateParam).trim()
      : (typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEYS.STATE) : null);
  // const path = `${baseUrl.replace(/\/$/, '')}/ai-webinar/try-ai-flow/onboarding-new`;
  const path = `${baseUrl.replace(/\/$/, '')}/ai-webinar`;

  const paramsdata = new URLSearchParams({
    planId: SIGNUP_WITHOUT_PAYMENT_FREE_TRIAL_PLAN_ID,

    // try_ai_prompt: state ? JSON.parse(state).try_ai_prompt : undefined,
  });
  const searchParams = new URLSearchParams(window.location.search);
  
    const payloadParam = searchParams.get("payload");

    if (payloadParam) {
      const decoded = decodeURIComponent(payloadParam);
      const payload = JSON.parse(decoded);

    const try_ai_prompt = payload.try_ai_prompt||localStorage.getItem('try_ai_prompt');
    const webinarType = payload.webinarType||localStorage.getItem('webinarType');
    const createMode = payload.createMode||localStorage.getItem('createMode');
    if (try_ai_prompt) {
      paramsdata.set('try_ai_prompt', try_ai_prompt);
    }
    if (webinarType) {
      paramsdata.set('webinarType', webinarType);
    }
    if (createMode) {
      paramsdata.set('createMode', createMode);
    }
  }else{
    const try_ai_prompt = localStorage.getItem('try_ai_prompt');
    const webinarType = localStorage.getItem('webinarType');
    const createMode = localStorage.getItem('createMode');
    if (try_ai_prompt) {
      paramsdata.set('try_ai_prompt', try_ai_prompt);
    }
    if (webinarType) {
      paramsdata.set('webinarType', webinarType);
    }
    if (createMode) {
      paramsdata.set('createMode', createMode);
    }
  }
  // Always send state param (as state) in the URL if it's present.
  if (state) {
    paramsdata.set('state', state);
  }
  return `${path}?${paramsdata.toString()}`;
}
